var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.select}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }